const config = {
	title: 'Temperature Daily Summary Report',
	name: 'temperatureDailySummary',
	defaultSort: 'Date desc',
	api: 'telemetry/summary',
	controllerType: 'elastic',
	readOnly: true,
	module: 'temperature',
	columns: [
		{
			field: 'sensorId',
			width: 220,
			header: 'Sensor',
			lookup: 'sensor',
			required: true,
			hideable: false,
			elasticFilter: false,
			sortable: false,
			filterable: false
		},
		{
			field: 'sensorCode',
			flex: 1,
			header: 'Sensor Code',
			type: 'string',
			readOnly: true,
			elasticFilter: false,
			sortable: false,
			filterable: false
		},
		{
			field: 'Date',
			flex: 1,
			header: 'Date',
			type: 'date',
			time: false,
			isLocal: true,
			elasticFilter: false,
			showDateOnly: true
		},
		{ field: 'avg', flex: 1, header: 'Avg', type: 'number', elasticFilter: false, renderCell: (params) => params.row?.avg != null ? `${params.row.avg} ${params.row?.unit || ''}`.trim() : '' },
		{ field: 'duration', flex: 1, header: 'Duration OOR', elasticFilter: false, filterable: false },
		{ field: 'min', flex: 1, header: 'Min', type: 'number', elasticFilter: false, filterable: false, renderCell: (params) => params.row?.min != null ? `${params.row.min} ${params.row?.unit || ''}`.trim() : '' },
		{ field: 'max', flex: 1, header: 'Max', type: 'number', elasticFilter: false, filterable: false, renderCell: (params) => params.row?.max != null ? `${params.row.max} ${params.row?.unit || ''}`.trim() : '' }
	]
};

export default config;
